import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/get/allStaff',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/foundation/addFoundation',
      data,
      dataType: 'form'
    });
  },
  // 添加奖励记录
  add(data) {
    return http.post({
      url: '/la/admin/add/staff',
      data,
      dataType: 'form'
    });
  },
  getStaffSumList(data) {
    return http.get({
      url: '/la/admin/get/staffFrozenAmountSum',
      data
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/update/staffStatus',
      data,
      dataType: 'form'
    });
  }
};
